/**
 * Created by razial on 02.01.2021
 */

const OpenChestWindow = CleverappsWindow.extend({
    onWindowLoaded: function (chest) {
        this.chest = chest;

        this.showAdOffer = Map2dLocation.currentLocation.location.locationConfig.isMain && !this.chest.extraPrizes && this.getPrize() && cleverapps.adsLimits.state(AdsLimits.TYPES.OPEN_CHEST) === AdsLimits.STATE_READY;

        this._super({
            title: cleverapps.unitsLibrary.getUnitName(chest.unit),
            name: "OpenChestWindow",
            content: this.createContent(),
            closeButton: true,
            help: function () {
                cleverapps.focusManager.display({
                    focus: "OpenChestHelpWindow",
                    stack: true,
                    action: (f) => {
                        new ChestPrizeProbWindow(chest.unit, Chest.ListPrizeProb(chest.unit));
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }
        });
    },

    beforeCloseAnimation: function (callback) {
        if (!this.isChestOpened) {
            callback();
            return;
        }

        const windowComponent = ComponentMap.get(this, WindowComponent);
        windowComponent.hideWindow();
        const chest = this.chest.unit.findComponent(Chest);

        if (!chest.checkFreeSpaceToOpen()) {
            callback();
            return;
        }

        chest.open();

        const options = { affected: this.chest.unit };
        Map2d.mapEvent(Map2d.OPENCHEST, options);
        cleverapps.tutorial.trigger(Map2d.OPENCHEST, options);

        const prizes = chest.listPrize();
        let delay = prizes.length * 150;

        if (Map2dLocation.currentLocation.tutorial.isActive() || cleverapps.tutorial.isActive()) {
            delay = Math.max(delay, 300);
        }

        Map2dLocation.currentLocation.counter.setTimeout(callback, delay);
    },

    openChest: function () {
        this.isChestOpened = true;
        this.close();
    },

    watchVideoAndOpenChest: function () {
        cleverapps.rewardedAdsManager.playRewarded(AdsLimits.TYPES.OPEN_CHEST, this.createListener(() => {
            this.chest.setExtraPrizes(this.getPrize());
            this.close();

            cleverapps.focusManager.display({
                focus: "OpenChestWindow",
                stack: true,
                action: (f) => {
                    new OpenChestWindow(this.chest);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }));
    },

    createContent: function () {
        const styles = cleverapps.styles.OpenChestWindow;

        const buttons = this.createButtons();
        const text = this.watchButton ? "OpenChestWindow.questionWithAd" : "OpenChestWindow.question";

        const question = cleverapps.UI.generateOnlyText(Messages.get(text, {
            name: Messages.get(this.chest.unit.getResource() === "sacks" ? "sack" : "chest")
        }), cleverapps.styles.FONTS.OPENCHESTWINDOW_TITLE_TEXT);
        question.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        question.setDimensions(styles.question.width, 0);

        return new cleverapps.Layout([this.createChest(), question, buttons], {
            margin: styles.margin
        });
    },

    createChest: function () {
        const styles = cleverapps.styles.OpenChestWindow.chest;

        let plus, extra;

        if (this.chest.extraPrizes) {
            plus = cleverapps.UI.generateImageText("+", cleverapps.styles.FONTS.OPENCHESTWINDOW_PLUS_TEXT);

            extra = UnitView.getUnitImage(this.getPrize());
            extra.setScale(styles.extra.scale);
            extra.clearTrack && extra.clearTrack(0);
        }

        const icon = new UnitOnCell(this.chest.unit, {
            energy: this.chest.isEnergyAvailable() && this.chest.getEnergyAmount(),
            shining: true,
            stripe: true
        });
        icon.setScale(styles.scale);

        return new cleverapps.Layout([icon, plus, extra], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
    },

    createButtons: function () {
        const buttons = [];
        const styles = this.showAdOffer ? cleverapps.styles.OpenChestWindow.showAd : cleverapps.styles.OpenChestWindow;
        const options = {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.buttons.margin,
            padding: styles.buttons.padding
        };

        if (this.showAdOffer) {
            buttons.push(this.createWatchButton());
            buttons.push(this.createOpenText());
        } else {
            buttons.push(this.createOpenButton());
        }

        return new cleverapps.Layout(buttons, options);
    },

    getPrize: function () {
        if (cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_ADS) {
            return OpenChestWindow.PRIZES_VIDEO_ADS_MAIN_MONETIZATION[this.chest.unit.stage];
        }
        return OpenChestWindow.PRIZES[this.chest.unit.stage];
    },

    createWatchButton: function () {
        const styles = cleverapps.styles.OpenChestWindow.showAd;

        const unit = UnitView.getUnitImage(this.getPrize(), { preferStatic: true });
        const options = {
            text: `%%${Messages.get("OpenChestWindow.freeGift")}##`,
            icons: {
                "%%": bundles.buttons_inlined_icons.frames.ad_icon_png,
                "^^": bundles.openchestwindow.frames.ads_arrow_png,
                "##": unit
            },
            width: styles.buttons.width,
            height: styles.buttons.height,
            onClicked: this.watchVideoAndOpenChest.bind(this)
        };

        const button = this.watchButton = new cleverapps.UI.Button(options);
        return button;
    },

    createOpenButton: function () {
        const styles = cleverapps.styles.OpenChestWindow.buttons;

        const button = new cleverapps.UI.Button({
            text: Messages.get("OpenChestWindow.button"),
            width: styles.width,
            height: styles.height,
            onClicked: this.openChest.bind(this)
        });
        button.adviceTarget = Map2d.SPAWN;

        return button;
    },

    createOpenText: function () {
        const styles = cleverapps.styles.OpenChestWindow;

        const openText = new cc.Node();
        openText.setAnchorPoint(0.5, 0.5);
        const text = cleverapps.UI.generateOnlyText(Messages.get("OpenChestWindow.rejectAd"), cleverapps.styles.FONTS.OPENCHESTWINDOW_LINK_TEXT);
        openText.addChild(text);
        cleverapps.UI.onClick(openText, this.openChest.bind(this), {
            interactiveScale: false
        });
        cleverapps.UI.applyHover(openText);
        openText.adviceTarget = Map2d.SPAWN;
        cleverapps.UI.wrap(openText);

        openText.setCascadeOpacityEnabledRecursively(true);
        openText.setOpacity(0);

        openText.runAction(
            new cc.Sequence(
                new cc.DelayTime(0.5),
                new cc.FadeIn(1),
                new cc.DelayTime(0.5),
                new cc.CallFunc(() => {
                    openText.addChild(cleverapps.UI.drawUnderline(text, styles.underline));
                })
            )
        );
        return openText;
    }
});

OpenChestWindow.PRIZES = [
    undefined,
    undefined,
    {
        code: "wands",
        stage: 0
    }
];

OpenChestWindow.PRIZES_VIDEO_ADS_MAIN_MONETIZATION = [
    undefined,
    {
        code: "wands",
        stage: 0
    },
    {
        code: "wands",
        stage: 1
    }
];

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    OPENCHESTWINDOW_TITLE_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    OPENCHESTWINDOW_PLUS_TEXT: {
        size: 92,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    OPENCHESTWINDOW_LINK_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.OpenChestWindow = {
    margin: 70,

    showAd: {
        buttons: {
            x: { align: "center" },
            y: { align: "bottom", dy: 85 },
            width: 480,
            height: 110,
            margin: 130,
            padding: {
                top: 40,
                bottom: 40,
                left: 160,
                right: 160
            }
        }
    },

    question: {
        width: 800
    },

    underline: {
        x: { align: "left", dx: 0 },
        y: { align: "bottom", dy: -2 },
        height: 3
    },

    buttons: {
        x: { align: "center" },
        y: { align: "bottom", dy: 85 },
        width: 300,
        height: 110,
        margin: 120,
        padding: {
            top: -35
        }
    },

    chest: {
        scale: 1.6,
        margin: 30,
        extra: {
            scale: 1.4
        }
    },

    watchButton: {
        unit: {
            x: { align: "right", dx: -19 },
            y: { align: "bottom", dy: 18 },
            scale: 1
        }
    }
};
